import { render, staticRenderFns } from "./barcodeInfo.vue?vue&type=template&id=35d424fa&scoped=true"
import script from "./barcodeInfo.vue?vue&type=script&lang=js"
export * from "./barcodeInfo.vue?vue&type=script&lang=js"
import style0 from "./barcodeInfo.vue?vue&type=style&index=0&id=35d424fa&prod&scoped=true&lang=css"
import style1 from "./barcodeInfo.vue?vue&type=style&index=1&id=35d424fa&prod&lang=css"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35d424fa",
  null
  
)

export default component.exports